var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SubmitButton',{attrs:{"loading":_vm.loading || _vm.loading2,"icon":"fa fa-file-excel","text":_vm.$t('ui.' + _vm.btnTxt),"type":"button","variant":"info","size":"sm"},on:{"click":function($event){return _vm.exportFile()}}})
}
var staticRenderFns = []

export { render, staticRenderFns }